export default {
  brancoAzulado: '#40445E',
  roxo: '#9900CF',
  cinzaClaro: 'rgb(255 255 255 / 50%)',
  cinzaClaroTransparente: 'rgb(255 255 255 / 20%)',
  branco: '#dbd9d9',
  roxoClaro: '#7a46a0',
  azulMassinha: '#94a3b8',
  azulClaro: '#caf8ff',
  pretoClaro: '#1c161c',
  preto: 'rgb(30 30 30)'
}
